import { tokens } from '@welbe/web-design-system';
import { ReactComponent as HeartIcon } from 'App/assets/img/heart.svg';
import styled from 'styled-components';

export const StyledHeartIcon = styled(HeartIcon)<{ color: string }>`
	path {
		fill: ${({ color }) => color || tokens.color_welbe};
	}
`;
